<script lang="ts">
import type { StudyMarketBattleSlideProps } from '$lib/components/study/slide-layout-types'
import StudyBattleCard from '../cards/StudyBattleCard.svelte'
import StudyBlueCalloutCard from '../cards/StudyBlueCalloutCard.svelte'
import StudySlideDoughnutCard from '../cards/StudySlideDoughnutCard.svelte'
import StudyVolumeCompareBarCard from '../cards/StudyVolumeCompareBarCard.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/**
 * Drug mix / manufacturer battle slide (`s5`): `.ey` / `.hl` + `.tc` with doughnut + battle card /
 * volume bar card + blue callout. `eyebrow` and `headline` use `{@html}`.
 */
let props: StudyMarketBattleSlideProps = $props()

const headlineStyle = props.headlineStyle ?? 'margin-bottom:1rem;'
const tcStyle = props.tcStyle ?? 'gap:1.4rem;align-items:start;'
const tcWeighted = props.tcWeighted ?? false
const d = props.doughnut
</script>

<StudySlide
  id={props.id}
  active={props.active}
  extraBottom={props.extraBottom}
  background={props.background}
  slideClass={props.slideClass}
>
  <StudySlideContent
    maxWidth={props.maxWidth ?? '980px'}
    contentClass={props.contentClass}
    style={props.contentStyle}
  >
    <div class="ey">{@html props.eyebrow}</div>
    <div class="hl" style={headlineStyle}>{@html props.headline}</div>
    <div class="tc" class:w={tcWeighted} style={tcStyle}>
      <div>
        <StudySlideDoughnutCard
          cardClass={d.cardClass ?? ''}
          cardStyle={d.cardStyle ?? 'margin-bottom:.72rem;'}
          active={props.active ?? false}
          title={d.title}
          subtitle={d.subtitle}
          labels={d.labels}
          data={d.data}
          colors={d.colors}
          type={d.type}
          cutout={d.cutout}
          legendPosition={d.legendPosition}
          tooltipFormat={d.tooltipFormat}
          height={d.height ?? '190px'}
        />
        <StudyBattleCard
          title={props.battleTitle}
          subtitle={props.battleSubtitle}
          left={props.battleLeft}
          right={props.battleRight}
        />
      </div>
      <div>
        <StudyVolumeCompareBarCard
          cardStyle="margin-bottom:.72rem;"
          title={props.volumeTitle}
          subtitle={props.volumeSubtitle}
          rows={props.volumeRows}
          maxCount={props.volumeMaxCount}
          barColors={props.volumeBarColors}
          formatValue={props.volumeFormatValue}
        />
        {#if props.calloutBodyHtml}
          <StudyBlueCalloutCard bodyHtml={props.calloutBodyHtml} />
        {/if}
      </div>
    </div>
  </StudySlideContent>
</StudySlide>
